import type { AppLocale } from "./locale";

export interface PreparedAppShare {
  preparedMessageId: string;
  preparedMessageExpiresAt: number | null;
  shareUrl: string;
}

export class AppShareApiError extends Error {
  constructor(
    public readonly code: string,
    public readonly status: number,
  ) {
    super(code);
  }
}

async function responseBody(response: Response): Promise<Record<string, unknown>> {
  try {
    return (await response.json()) as Record<string, unknown>;
  } catch {
    return {};
  }
}

export async function prepareAppShare(
  initData: string,
  locale: AppLocale,
): Promise<PreparedAppShare> {
  const response = await fetch("/api/share-app", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ initData, locale }),
  });
  const body = await responseBody(response);
  if (!response.ok) {
    throw new AppShareApiError(
      typeof body.error === "string" ? body.error : "share_failed",
      response.status,
    );
  }
  if (
    typeof body.preparedMessageId !== "string" ||
    typeof body.shareUrl !== "string"
  ) {
    throw new AppShareApiError("invalid_share_response", 502);
  }
  return {
    preparedMessageId: body.preparedMessageId,
    preparedMessageExpiresAt:
      typeof body.preparedMessageExpiresAt === "number"
        ? body.preparedMessageExpiresAt
        : null,
    shareUrl: body.shareUrl,
  };
}
